import { DateTime } from "luxon"
import { isCancelledLesson } from "./cancellation.utils"
import { isMatch } from "./match.utils"
import { hasLessonNotes } from "./lessonContent.utils"

// ── LA LEZIONE APPENA FINITA ───────────────────────────────────────
// Una lezione finita oggi aspetta le note (#166) fino a mezzanotte, o finché
// non ci si scrivono: il diario o una riga su un allievo. Le annullate non si
// sono fatte, e quando giochi tu non c'è niente da raccontare. Chi la lezione
// non la può modificare (un assistente) le note non le scrive: lo decide chi
// la mostra.
const toDateTime = value =>
	typeof value?.toDate === "function" ? DateTime.fromJSDate(value.toDate()) : null

export const awaitsLessonNotes = (lesson, now = DateTime.now()) => {
	const end = toDateTime(lesson?.lessonEnd)
	if (!end || end > now || !end.hasSame(now, "day")) return false
	if (isCancelledLesson(lesson) || isMatch(lesson)) return false
	return !hasLessonNotes(lesson.lessonContent)
}

// In agenda le chiede solo l'ultima, col biglietto in fondo alla scheda
// (#214): la sera, una per lezione, erano un muro arancione. Le altre le
// note le prendono dalla lezione aperta.
export const latestAwaitingNotes = (lessons, now = DateTime.now()) =>
	lessons
		.filter(lesson => awaitsLessonNotes(lesson, now))
		.reduce(
			(latest, lesson) =>
				!latest || toDateTime(lesson.lessonEnd) > toDateTime(latest.lessonEnd) ? lesson : latest,
			null,
		)

// "Appena finita · 5 minuti fa" per la prima ora, poi l'ora in cui è finita:
// "3 ore fa" la sera vuol dire poco, "Finita alle 17:30" si riconosce
export const finishedLabel = (lessonEnd, now = DateTime.now()) => {
	const end = toDateTime(lessonEnd)
	if (!end) return "Finita"
	const minutes = Math.floor(now.diff(end, "minutes").minutes)
	if (minutes < 1) return "Appena finita"
	if (minutes < 60) return `Appena finita · ${minutes === 1 ? "1 minuto" : `${minutes} minuti`} fa`
	return `Finita alle ${end.toFormat("HH:mm")}`
}
